
import NotFound from 'components/NoPage';
import Auth from 'pages/Auth';
import ForgotPassword from 'pages/Auth/ForgetPassword';
import Login from 'pages/Auth/Login';
import Register from 'pages/Auth/Register';
import ResetPassword from 'pages/Auth/ResetPassword';
import Budget from 'pages/Dashboard/Budget';
import Dashboard from 'pages/Dashboard';
import Metrics from 'pages/Dashboard/Metrics';
import Report from 'pages/Dashboard/Report';
import { BrowserRouter, Routes, Route,Navigate } from "react-router-dom";
import Verify from 'pages/Auth/Verify';
import Settings from 'pages/Dashboard/Settings'
import UpdateProfile from 'pages/Dashboard/UpdatePatientProfile';
import Vault from 'pages/Dashboard/Vault'
import { useSelector } from "react-redux";
import { RootState } from "store";

const App = () => {
  
  const isAuthenticated = useSelector((state:RootState )=> state.userData.isAuthenticated)

  return (
    <div className="App relative">
      <BrowserRouter>
      <Routes>
        <Route element={<Auth />} >
          <Route path='/' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/forgot_password' element={<ForgotPassword />} />
          <Route path='/reset_password' element={<ResetPassword />} /> 
          <Route path='/verify' element={<Verify />} /> 
        </Route>
        <Route path='dashboard' element={isAuthenticated ? <Dashboard /> : <Navigate to ="/"/> } >
          <Route index element={isAuthenticated ?<Metrics /> : <Navigate to ="/"/> }/>
          <Route path='report' element={isAuthenticated ? <Report /> : <Navigate to ="/"/> }/>
          <Route path='budget' element={isAuthenticated ?<Budget /> : <Navigate to ="/"/> }/>
          <Route path='settings' element={isAuthenticated ? <Settings /> : <Navigate to ="/"/> }/>
          <Route path='vault' element={isAuthenticated ? <Vault /> : <Navigate to ="/"/> }/>
          <Route path='update_profile' element={isAuthenticated ? <UpdateProfile /> : <Navigate to ="/"/> }/>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    </div>

  );
}

export default App;
